import {
  AUTOMOTIVE_ICON,
  BEAUTY_ICON,
  FASHION_ICON,
  FOOD_ICON,
  CANNABIS_ICON,
  FINANCE_ICON,
  TECHNOLOGY_ICON,
  TRAVEL_ICON,
  COFFEE_ICON,
  ALCOHOL_ICON,
}
  from './image';

export default [
  {
    icon: FOOD_ICON,
    heading: 'Food/Drink',
    key: 'food_dink',
    tagLine: 'Ex- Packaged food & drinks, restaurants, food delivery and coffee',
  },

  {
    icon: ALCOHOL_ICON,
    heading: 'Alcohol',
    key: 'alcohol',
    tagLine: 'Ex- Spirits, beer and wine.',
  },
  {
    icon: CANNABIS_ICON,
    heading: 'Cannabis/CBD/Brands',
    key: 'cannabis',
    tagLine: 'if you had to get higher',
  },
  {
    icon: FASHION_ICON,
    heading: 'Fashion',
    key: 'fashion',
    tagLine: 'Ex- Clothes, accessories shoes and fitness apparel.',
  },

  {
    icon: FINANCE_ICON,
    heading: 'Finance',
    key: 'finance',
    tagLine: 'Ex- Banks, Investing apps and credit cards.',
  },

  {
    icon: BEAUTY_ICON,
    heading: 'Health/Beauty/Fitness',
    key: 'health_beauty',
    tagLine: 'Ex- Skincare, makeup, gyms, athletic equipment and bicycles.',
  },

  {
    icon: TECHNOLOGY_ICON,
    heading: 'Tech/Entertainment',
    key: 'tech_entertainment',
    tagLine: 'Ex- Phones, gaming, computers and movies.',
  },

  {
    icon: AUTOMOTIVE_ICON,
    heading: 'Automotive',
    key: 'automotive',
    tagLine: 'Ex- Cars, trucks and motorcycles.',
  },

  {
    icon: TRAVEL_ICON,
    heading: 'Travel',
    key: 'travel',
    tagLine: 'Ex- Airlines, hotels, resorts and rideshare.',
  },

  {
    icon: COFFEE_ICON,
    heading: 'Other',
    key: 'other',
    tagLine: 'Other activities and brands you are passionate about.',
  },

];
